import React, {useEffect, useState} from 'react';
import { Helmet } from 'react-helmet';
import brand from 'dan-api/dummy/brand';
import PapperBlock from 'dan-components/PapperBlock/PapperBlock';
import SearchForm from '../../../components/Forms/SearchForm';
import List from '../../../components/Lists/List';
import { withRouter } from 'react-router';
import { withCookies } from 'react-cookie';
import MySnackbar from '../../../components/Notification/StyledNotif';
import { connect } from 'react-redux';
import { onFetchIndexPaymentFormAction } from '../../../redux/actions/paymentForm';
import { onFetchIndexUserAction, onFetchExportAction } from '../../../redux/actions/user';
import accessToken from '../../../utils/accessToken';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import styles from '../../../components/Forms/user-jss';
import { enumToJa } from '../../../utils/format';
import Loading from '../../../components/Loading/index'
import CsvExportDialog from '../../../components/Dialog/CsvExportDialog';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import AlertDialog from "../../../components/Dialog/AlertDialog";

function Index(props) {
  const { classes } = props;
  const { companies } = props.internalValues

  const title = brand.name + ' - 会員一覧';
  const description = brand.desc;
  const url = '/admin/user/'

  // 検索項目
  const [searchItems, setSearchItems] = useState(
    [
      { label: "会員番号" , name: "user_no" , value: "" , formType: "text"},
      { label: "メールアドレス" , name: "email" , value: "" , formType: "text"},
      // TODO 継続課金実装時コメント解除
      // { label: "会員種別" , name: "type" , value: "" , formType: "select" , menuItems: [{key: '通常会員' , value: 'normal'} , {key: '非会員' , value: 'guest'} , {key: '継続課金会員' , value: 'plan'}]},
      // { label: "会員種別" , name: "type" , value: "" , formType: "select" , menuItems: [{key: '通常会員' , value: 'normal'} , {key: '非会員' , value: 'guest'}]},
      { label: "会員種別" , name: "type" , value: "" , formType: "select" , menuItems: [{key: '継続課金会員' , value: 'plan'}]},
      { label: "ステータス" , name: "status" , value: "" , formType: "select" , menuItems: [{key: '有効' , value: '1'} , {key: '無効' , value: '0'}]},
      {label: "姓", name: "last_name", value: "", formType: "text"},
      {label: "名", name: "first_name", value: "", formType: "text"},
      {label: "決済フォーム", name: "payment_form_id", value: "", formType: "select_suggestion"},
      {label: "フォーム項目名", name: "payment_form_item_name", value: "", formType: "text"},
      {label: "フォーム項目説明", name: "payment_form_item_description", value: "", formType: "text"},
      {label: "フォーム回答内容", name: "payment_form_item_answer", value: "", formType: "text"},
      { label: "加盟店名", name: "company_id", value: "", formType: "select", super: true,
        menuItems: companies ? companies.map( (company) => ({key: company.name, value: company.id} )) : null
      },
      { label: "登録日時〜", name: "created_at_start", value: null, formType: "datetime" },
      { label: "〜登録日時", name: "created_at_end", value: null, formType: "datetime" },
    ]
  )

  const [indexPaymentFormData, setIndexPaymentFormData] = useState([]);

  const fetchIndexPaymentForm = company_id => {
    let data = {}
    if (company_id){
      data.company_id = company_id
    }
    data.page = 'all'
    props.onFetchIndexPaymentForm({
      accessToken: accessToken(props),
      data: data,
      onSuccess: data => {
        const item = data
        setIndexPaymentFormData(item.data)
      },
      onErrorWithNotice: error => {
        displayNotification(error)
      }
    })
  };

  useEffect(() => {
    const newCompanyId = searchItems.find(item => item.name === "company_id").value;
    fetchIndexPaymentForm(newCompanyId)
  }, [searchItems && searchItems.find(item => item.name === "company_id").value]);

  const [listItems, setlistItems] = useState(
    [
      { label: "加盟店名", name: "company", super: true}, 
      { label: "氏名", name: "user-name"},
      { label: "メールアドレス", name: "email"},
      { label: "会員番号", name: "user-no"},
      { label: "ステータス", name: "status", format: (value)=>{return enumToJa(value['status'])}},
      { label: "エクスポート状況", name: "exported"}
    ]
  )

  // 一覧
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState("")
  const [sort, setSort] = useState('desc');
  const [isExportDialogOpen, setIsExportDialogOpen] = useState(false);
  const [count, setCount] = useState(0);
  const [excludeExported, setExcludeExported] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  
  const submitForm = (values, page = 1) => {
    let data = {}
    searchItems.forEach(item => { data[item.name] = item.value})
    if (values === 'sort') {
      if (sort === 'desc') {
        setSort('asc')
        data['sort'] = 'asc'
      } else {
        setSort('desc')
        data['sort'] = 'desc'
      }
    } else {
      data['sort'] = sort
    }
    if (excludeExported) {
      data.exported = 'false';
    }
    data.page = page
    props.onFetchIndexUser({
      accessToken: accessToken(props),
      data: data,
      onSuccess: data => {
        const item = data
        setUserData(item)
        if (item.meta['total-count'] > 10000) {
          setIsDialogOpen(true);
          return;
        }
        setCount(item.meta['total-count'])
        if (!item.data.length) {
          displayNotification("検索結果がありませんでした", 'warning')
          return
        }
        if (values === 'export') {
          setCount(item.meta['total-count'])
          setIsExportDialogOpen(true);
        }
        setLoading(false)
      },
      onErrorWithNotice: error => {
        displayNotification(error)
      }
    })
  };

  // メッセージ関連
  const location = props.location
  const [notification, setNotification] = useState({
    openStyle: location.message ? true : false,
    message: location.message ? location.message : '',
    variant: location.message ? location.variant : 'info'
  });
  const displayNotification = (message , valiant ='error') => {
    setNotification({
      openStyle: true,
      message: message,
      variant: valiant
    });
  }

  const changeValue = (index,value) => {
    searchItems[index].value = value
    setSearchItems(searchItems.slice())
  }
  const handleExport = () => {
    let data = {}
    searchItems.forEach(item => {
      data[item.name] = item.value
    })
    if (excludeExported) {
      data.exported = 'false'
    }
    props.onFetchExport({
      accessToken: accessToken(props),
      data: data,
      onSuccess: data => {
      },
      onErrorWithNotice: error => {
        displayNotification(error)
      }
    })
  };

  return (
    <div>
      <Helmet>
      <title>{title}</title>
      </Helmet>
      <PapperBlock title="会員検索" whiteBg icon="ios-search-outline" desc="">
        <section className={classes.formWrap}>
          <Grid container spacing={3}>
            { searchItems.map( (item, index) => {
                return(
                  <Grid key={index} item xs={12} sm={item.formType === 'select_suggestion' ? 12 : 6}>
                    <SearchForm searchItem={item} key={index} id={index} changeValue={changeValue} role={props.internalValues.role} indexPaymentFormData={indexPaymentFormData}/>
                  </Grid>
                )}
              )
            }
          </Grid>
        </section>
          <div className={classes.btnArea}>
            <Grid container justifyContent="center" spacing={2}>
              <Grid item xs={12} container justifyContent="center">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={excludeExported}
                      onChange={e => setExcludeExported(e.target.checked)}
                      color="primary"
                    />
                  }
                  label="一度エクスポートした情報は除く"
                />
              </Grid>
              <Grid item>
                <Button variant="contained" color="primary" size="large" onClick={submitForm}>
                  検索
                </Button>
              </Grid>
              <Grid item>
                <Button variant="contained" color="primary" size="large" onClick={() => submitForm('export')}>
                  CSVエクスポート
                </Button>
              </Grid>
            </Grid>
          </div>
      </PapperBlock>
      {/*検索を開始するまでは一覧は表示しない
         検索を開始し、管理者一覧APIが終了するまではローディング画面
         管理者一覧APIが終了し、データが格納されていない場合は一覧は表示しない
         管理者一覧APIが終了し、データが格納されている場合は一覧を表示*/}
      {loading || userData.data.length === 0 ?  "" :
          <PapperBlock title="会員一覧" whiteBg icon="ios-list" desc="" sort="true" submitForm={submitForm}>
            { props.loadingUserIndex ? 
              <div><List listItems={listItems} searchResult={userData} url={url} submitForm={submitForm} role={props.internalValues.role} browsingRight={props.internalValues.browsingRight} /><Loading /></div> :
              <List listItems={listItems} searchResult={userData} url={url} submitForm={submitForm} role={props.internalValues.role} browsingRight={props.internalValues.browsingRight} />
            }
          </PapperBlock>
      }
      <CsvExportDialog open={isExportDialogOpen} count={count} onExport={handleExport} onClose={setIsExportDialogOpen}/>
      <AlertDialog
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        title="CSVエクスポート上限超過"
        content="一度にCSVエクスポートできるのは10,000件までです。\n検索条件を変更して対象件数を減らしてください。"
      />
      <MySnackbar onClose={() => setNotification({...notification, openStyle:false})} notification={notification} />
    </div>
  );
}

Index.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    internalValues: state.getIn(['internalReducers', 'internalValues']),
    loadingUserIndex: state.getIn(['userReducers', 'loadingUserIndex']),
    loadingExport: state.getIn(['userReducers', 'loadingExport']),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onFetchIndexUser: data => {
      dispatch(onFetchIndexUserAction(data));
    },
    onFetchIndexPaymentForm: data => {
      dispatch(onFetchIndexPaymentFormAction(data));
    },
    onFetchExport: data => {
      dispatch(onFetchExportAction(data));
    }
  };
};

const FormInit = connect(
  mapStateToProps,
  mapDispatchToProps
)(Index);

export default withStyles(styles)(withCookies(withRouter(FormInit)));
